import { ScreenCompanyNew } from '@dms/screen'

export default ScreenCompanyNew
